/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamGridQueryResponse,
  GetApiV1ExamGridQueryParams,
  GetApiV1ExamGrid400,
  GetApiV1ExamGrid401,
  GetApiV1ExamGrid500,
} from "../../types/examEvaluationController/GetApiV1ExamGrid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamGrid } from "../../clients/examEvaluationController/getApiV1ExamGrid.ts";

export const getApiV1ExamGridQueryKey = (
  params?: GetApiV1ExamGridQueryParams,
) => [{ url: "/api/v1/exam/grid" }, ...(params ? [params] : [])] as const;

export type GetApiV1ExamGridQueryKey = ReturnType<
  typeof getApiV1ExamGridQueryKey
>;

export function getApiV1ExamGridQueryOptions(
  params?: GetApiV1ExamGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamGridQueryKey(params);
  return queryOptions<
    GetApiV1ExamGridQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamGrid400 | GetApiV1ExamGrid401 | GetApiV1ExamGrid500
    >,
    GetApiV1ExamGridQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamGrid(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de provas para exibição no grid principal de avaliação, com suporte a filtros por disciplina, empresa, título, status (ativo/inativo), tipo de prova e status de planejamento. **(Requer Authorization para autenticação)**
 * @summary Listar provas no grid (Requer Authorization para autenticação)
 * {@link /api/v1/exam/grid}
 */
export function useGetApiV1ExamGrid<
  TData = GetApiV1ExamGridQueryResponse,
  TQueryData = GetApiV1ExamGridQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamGridQueryKey,
>(
  params?: GetApiV1ExamGridQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamGridQueryResponse,
        ResponseErrorConfig<
          GetApiV1ExamGrid400 | GetApiV1ExamGrid401 | GetApiV1ExamGrid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamGridQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamGridQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1ExamGrid400 | GetApiV1ExamGrid401 | GetApiV1ExamGrid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
